export interface MengenEingabeEinheit {
  arteh: string;
  bezeichnung: string;
  faktor: number;
  kzausgabe: string;
  id: number;
}
